import routerOptions0 from "/usr/src/app/content/n3-treatments-09ff3456-8b53-4936-b711-b1eafbe9c9df/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}